<div class="app-policy-field-effective-policy-settings-button">
    <button class="confirm" type="submit" (click)="buttonClicked()">
        {{ "View Rules" }}
    </button>
</div>
